import React, { createContext, useCallback, useReducer, useEffect } from 'react';
import { Classroom } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import {
  get,
  put,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/local-storage-util';
import UseUserClassroom from 'graph/state/query-hooks/use-user-classrooms';
import { defaultState, reducers } from './reducers';
import { Actions, UseClassroomState } from './types';
import { isEmpty } from 'lodash';
import { LocalStorage } from 'types';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';

export const ClassroomContext = createContext<any>([]);

export const ClassroomProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer<React.Reducer<UseClassroomState, Actions>>(
    reducers,
    defaultState()
  );
  const [user] = useUserStore();

  const [{ classrooms, isLoading, error }, { refetch }] = UseUserClassroom(user?.me?.id);

  const classroomId = get(LocalStorage.CLASSROOM_ID)?.[LocalStorage.CLASSROOM_ID];

  const setActiveClassroom = useCallback((classroom: Classroom) => {
    put(LocalStorage.CLASSROOM_ID, { [LocalStorage.CLASSROOM_ID]: classroom.id });
    dispatch({ type: 'SET_ACTIVE_CLASSROOM', payload: { classroom } });
  }, []);

  const classroomRefetch = () => refetch();

  useEffect(() => {
    if (classrooms?.length && !isLoading && !error) {
      dispatch({ type: 'SET_CLASSROOMS', payload: { classrooms } });
    }
  }, [isLoading, error]);

  useEffect(() => {
    dispatch({ type: 'SET_LOADING', payload: { isLoading } });
  }, [isLoading]);

  useEffect(() => {
    if (!classrooms?.length || isLoading || error) return;

    if (classroomId) {
      const foundClass = classrooms.find((c) => c.id === classroomId);
      if (foundClass) {
        setActiveClassroom(foundClass);
        return;
      }
    }

    isEmpty(state.activeClassroom) && setActiveClassroom(classrooms?.[0]); //set active classroom to first in list.
  }, [classroomId, isLoading, error]);

  return (
    <ClassroomContext.Provider
      value={[
        state,
        {
          setActiveClassroom,
          classroomRefetch,
        },
      ]}
    >
      {children}
    </ClassroomContext.Provider>
  );
};

export default ClassroomProvider;
